import './Helper/style';

const Title = props => {
	const { mt, mb, children } = props;

	return <p className='bPlLabel' style={{ marginTop: `${mt || '20px'}`, marginBottom: `${mb || '5px'}` }}>{children}</p>;
};
export default Title;